import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">Terms & Conditions</h1>
      <p>Last Updated: 10 October 2025</p>

      <h2 className="font-semibold text-xl mt-6 mb-2">1. Introduction</h2>
      <p>
        Welcome to Bricksnmix. By accessing or using our website, mobile app,
        and offline services, you agree to comply with these Terms &
        Conditions. If you do not agree with any part of these terms, please
        discontinue using our services.
      </p>

      <h2 className="font-semibold text-xl mt-6 mb-2">2. Eligibility</h2>
      <p>
        You must be at least 18 years old to use Bricksnmix services. By using
        our platform, you confirm that the information you provide is accurate
        and complete.
      </p>

      <h2 className="font-semibold text-xl mt-6 mb-2">3. Offline Purchase Policy</h2>
      <p>
        If your device goes offline, you may still place orders through
        authorized partners or service centers. All offline transactions will be
        synced to your account once an internet connection is restored.
      </p>

      <h2 className="font-semibold text-xl mt-6 mb-2">4. Pricing & Payments</h2>
      <p>
        All prices listed on Bricksnmix are subject to change without prior
        notice. Payments must be made using the approved payment methods
        available at checkout.
      </p>

      <h2 className="font-semibold text-xl mt-6 mb-2">5. Return & Refund Policy</h2>
      <p>
        Returns and refunds follow our standard return policy. Offline orders
        also follow the same policy. Customers must provide receipts or order
        reference numbers for smooth processing.
      </p>

      <h2 className="font-semibold text-xl mt-6 mb-2">6. User Responsibilities</h2>
      <p>
        You agree not to misuse our platform, upload harmful content, or
        interfere with system operations. Any fraudulent activity will result in
        immediate termination of your access.
      </p>

      <h2 className="font-semibold text-xl mt-6 mb-2">7. Intellectual Property</h2>
      <p>
        All logos, designs, content, and materials on Bricksnmix are the
        property of Bricksnmix and cannot be reproduced without permission.
      </p>

      <h2 className="font-semibold text-xl mt-6 mb-2">8. Limitation of Liability</h2>
      <p>
        Bricksnmix is not responsible for delays, losses, or damages arising
        from offline usage, shipping issues, or third-party partner errors.
      </p>

      <h2 className="font-semibold text-xl mt-6 mb-2">9. Termination</h2>
      <p>
        Bricksnmix reserves the right to suspend or terminate user accounts for
        policy violations or suspicious activities.
      </p>

      <h2 className="font-semibold text-xl mt-6 mb-2">10. Contact Support</h2>
      <p>
        For any issues, contact our support team or visit a Bricksnmix partner
        store.
      </p>
    </div>
  );
};

export default TermsAndConditions;
